/**
 * Ficha marcada como cópia no Google (conflito de propriedade).
 *
 * A conta conectada enxerga a ficha, mas outra conta é a dona verificada — editar,
 * publicar post e responder avaliação pela API não funcionam. Até 29/09/2026 a lista
 * simplesmente escondia essas fichas, e o operador concluía que a empresa não estava
 * no sistema (Thiago, agosto e setembro de 2026). Agora ela aparece com selo, as ações
 * ficam travadas com a explicação, e sobra o "Reconferir no Google".
 */

export const SELO_COPIA = "Duplicata no Google";

export const MOTIVO_COPIA =
  "Duplicata no Google: outra conta é a dona verificada desta ficha, então as ações " +
  "pelo GeoRanking não funcionam. Resolva no Perfil da Empresa (pedir acesso ao dono " +
  "ou remover a duplicata) e depois clique em Reconferir no Google. O sistema também " +
  "reconfere sozinho todo dia.";

export const AVISO_DUPLICATA =
  "Existe outra ficha desta empresa no Google marcada como duplicata. Duplicata divide " +
  "avaliações e posição — vale pedir a remoção dela no Perfil da Empresa.";

/** Perdemos o acesso à ficha no Google (pedido do Reinaldo, 19/10/2026: "deixar claro sem acesso"). */
export const SELO_SEM_ACESSO = "Sem acesso";

export const MOTIVO_SEM_ACESSO =
  "Perdemos o acesso a esta ficha no Google: nenhuma das nossas contas gerencia mais o perfil. " +
  "Postagens, respostas e edições não chegam ao Google até o cliente nos dar acesso de novo.";

export const semAcesso = (estado?: string | null) => estado === "SEM_ACESSO";

export const RECONFERIR_TOOLTIP =
  "Reconferir no Google agora (use depois que o cliente resolver o conflito)";

/** Trava a ação quando a ficha é cópia, trocando o tooltip pela explicação. */
export function travarSeCopia<T extends { disabled?: boolean; tooltip: string }>(
  acao: T,
  copia: boolean,
): T {
  if (!copia) return acao;
  return { ...acao, disabled: true, tooltip: MOTIVO_COPIA };
}

/** Botão das fichas que não são cópia: confere agora se a nossa conta ainda enxerga a ficha. */
export const RECONFERIR_ACESSO_TOOLTIP =
  "Reconferir acesso no Google agora (use depois de tirar ou devolver o acesso; sem esperar a leitura das 7h)";
